<template>
<div>
  <tag-text-field label="Roles you will consider" placeholder="Role"
    v-model="roles" :error="roleError" @blur="roleValidate" />
  <tag-location-field label="Locations" v-model="locations" :error="locationsError" @validate="locationsValidate" />
  <field label="Remote friendly" class="remote-location" >
    <div class="control">
      <toggle-button v-model="remoteLocation" :isEditable="true" />
    </div>
  </field>
<!--  <field label="Job type" class="contractType">-->
<!--    <div class="control">-->
<!--      <tag-select :options="contractTypeList" v-model="contractTypes" :error="contactTypeError" @validate="contactTypeValidate" />-->
<!--    </div>-->
<!--  </field>-->
  <multi-select label="Job type" v-model="contractTypes" placeholder="Type to search the job type" :error="contactTypeError" :options="jobTypesJobSeekerForm" ></multi-select>
  <div class="field is-horizontal salary">
    <div class="field-body">
      <CurrencyField label="Salary expectations (min)" v-model="salary"
      @blur="validateData" placeholder="Min salary" :error="salaryError"></CurrencyField>
      <text-field label="Notice period (days)" @blur="validateData"
          :error="noticePeriodError"
          placeholder="Notice period in days" v-model="noticePeriodInDays" />
    </div>
  </div>
  <divider />
  <h1 class="title is-4" v-if="resumeTitle">
    Attach CV
  </h1>
  <div>
    <label>{{resumeLabelText}}</label>
    <p class="subtitle-text txt-help">Recommended for Jobseekers</p>
    <resume-upload-field v-model="resume" :uploading="uploading" :isFullWidth="true" />
  </div>
  <divider />
  <div>
    <label for="">Attach Mundo Crypto Certificate</label>
    <p class="subtitle-text txt-help">Recommended for Mundo Crypto Students</p>
    <upload-field :error="null" :documentStatus="mundoCryptoCerStatus" :documentUrl="mundoCryptoCerUrl" placeholder="Attach Document here" tooltip="Attach your Mundo Crypto Certificate" v-model="mundoCertificateCer" :uploading="uploadingMundoCrypto" :isFullWidth="true" />
  </div>
  <divider />
  <h1 class="title is-4" v-if="resumeTitle">
    {{this.$t('signup.joinEcosystem')}}
  </h1>
  <hirer-autocomplete :label="getAutocompleteTitle" v-model="talentPools"></hirer-autocomplete>
</div>
</template>

<script>
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
import TagSelect from '@/components/general/tag-select'
import Field from '@/components/general/field'
import TextField from '@/components/general/text-field'
import TagTextField from '@/components/general/tag-text-field'
import TagLocationField from '@/components/general/location-tag-autocomplete'
import ResumeUploadField from '@/components/jobseekers/resume-upload-field'
import Divider from '@/components/general/divider'
import CurrencyField from '@/components/general/currency-text-field'
import ToggleButton from '@/components/toggle'
import HirerAutocomplete from '@/components/signup/hirer-autocomplete'
import Validators from '@/helpers/validators'
import UploadField from '@/components/general/upload-field'
import MultiSelect from '../multi-select.vue'
import {jobTypesJobSeekerForm} from '../../constants/array-constants'
import {getContractTypeForEdit} from '../../helpers/general-helpers'

export default {
  components: {
    UploadField,
    TagSelect,
    ResumeUploadField,
    Divider,
    Field,
    TextField,
    TagTextField,
    TagLocationField,
    CurrencyField,
    Validators,
    ToggleButton,
    HirerAutocomplete,
    MultiSelect
  },
  props: {
    resumeTitle: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      contractTypeList: [
        'Permanent',
        'Contract',
        'Voluntary',
        'Freelance',
        'Bounty',
        'Co-Founder / Equity Only'
      ],
      contracts: [],
      noticePeriodError: null,
      salaryError: null,
      roleError: null,
      locationsError: null,
      contactTypeError: null,
      uploading: false,
      showBanner: true,
      uploadingMundoCrypto: false,
      jobTypesJobSeekerForm,
      contractTypesValue: []
    }
  },
  computed: {
    getAutocompleteTitle () {
      return this.resumeTitle ? this.$t('signup.thisWillSignal') : this.$t('profile.jobsBoard') + ':'
    },
    ...mapState('jobseekerForm', {
      formResume: 'resume'
    }),
    ...mapState('jobseekerForm', {
      formRoles: 'roles',
      formLocations: 'locations',
      formContractTypes: 'contractTypes',
      formNoticePeriod: 'noticePeriodInDays',
      formSalary: 'salary',
      formResume: 'resume',
      formRemoteLocation: 'isRemoteAvailable',
      formTalentPools: 'talentPools',
      formMundoCryptoCer: 'mundoCryptoCer'
    }),
    ...mapGetters('jobseekerProfiles', [
      'mundoCryptoCerUrl',
      'mundoCryptoCerStatus'
    ]),
    remoteLocation: {
      get () { return this.formRemoteLocation },
      set (value) {
        this.setRemoteLocation(value)
      }
    },
    roles: {
      get () { return this.formRoles },
      set (value) {
        this.setRoles(value)
        this.roleValidate()
      }
    },
    locations: {
      get () { return this.formLocations },
      set (value) {
        this.setLocations(value)
        this.locationsValidate()
      }
    },
    contractTypes: {
      get () { return this.contractTypesValue },
      set (value) {
        this.contractTypesValue = value
        const storeValue = value.map(item => item.id)
        this.setContractTypes(storeValue)
        this.contactTypeValidate()
      }
    },
    noticePeriodInDays: {
      get () { return `${this.formNoticePeriod}` },
      set (value) {
        this.setNoticePeriodInDays(value.trim())
      }
    },
    salary: {
      get () { return this.formSalary },
      set (value) { this.setSalary(value) }
    },
    resumeLabelText () {
      return this.resumeTitle ? 'CV' : 'Attach CV'
    },
    resume: {
      get () { return this.formResume },
      set (value) { this.uploadResume(value) }
    },
    mundoCertificateCer: {
      get () { return this.formMundoCryptoCer },
      set (value) { this.uploadMundoCryptoCer(value) }
    },
    talentPools: {
      get () { return this.formTalentPools },
      set (value) { this.setTalentPools(value) }
    }
  },
  mounted () {
    if (this.formContractTypes.length > 0) {
      this.contractTypesValue = getContractTypeForEdit(this.formContractTypes)
    }
  },
  methods: {
    ...mapMutations('jobseekerForm', [
      'setRemoteLocation',
      'setLocations',
      'setRoles',
      'setContractTypes',
      'setNoticePeriodInDays',
      'setSalary',
      'loadWithProfile',
      'setTalentPools'
    ]),
    ...mapActions('jobseekerProfiles', [
      'uploadJobseekerResume', 'uploadMundoCrypto'
    ]),
    roleValidate () {
      if (this.formRoles.length === 0) {
        this.roleError = 'Required'
      } else {
        this.roleError = null
      }
    },
    locationsValidate () {
      if (this.formLocations.length === 0) {
        this.locationsError = 'Required'
      } else {
        this.locationsError = null
      }
    },
    contactTypeValidate () {
      if (this.formContractTypes.length === 0) {
        this.contactTypeError = 'Required'
      } else {
        this.contactTypeError = null
      }
    },
    validateData () {
      let error = false
      this.noticePeriodError = Validators.validateNoticePeriod(this.formNoticePeriod)
      this.salaryError = Validators.validateSalary(this.salary)
      if (this.noticePeriodError !== null || this.salaryError !== null) {
        error = true
      }
      this.$emit('error', error)
    },
    async uploadResume (file) {
      if (file) {
        this.uploading = true
        await this.uploadJobseekerResume(file)
        this.uploading = false
      }
    },
    async uploadMundoCryptoCer (file) {
      if (file) {
        this.uploadingMundoCrypto = true
        await this.uploadMundoCrypto(file)
        this.uploadingMundoCrypto = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.button.is-static {
  font-weight: normal;
}

.field-body .field {
  margin-bottom: 0;
}

.field:not(:last-child) {
  margin-bottom: 1.5rem
}
.remote-location {
  margin-bottom: 1.375rem !important
}

@media (min-width: 1150px) {
  .subtitle-text{
    display: inline-block !important;
    float: right;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/jobseekers/jobseeker-form.vue